function mergeIf(lastItem, currentItem, i) {
  return !lastItem.blockcode;
}

/**
 * Checks if the lastItem toMinutesAfterMidnight differs from currentItem.fromMinutesAfterMidnight - means no chain
 * @param lastItem
 * @param currentItem
 * @returns {boolean}
 */
function isChainBroken(lastItem, currentItem) {
  return lastItem.toMinutesAfterMidnight !== currentItem.fromMinutesAfterMidnight; // means skipping if no chain is there
}
export default {
  yearMonthSortComparator(a, b) {
    let aParts = a.split('_');
    let bParts = b.split('_');
    let aYear = Number(aParts[0]);
    let bYear = Number(bParts[0]);
    let aMonth = Number(aParts[1]);
    let bMonth = Number(bParts[1]);
    if (aYear === bYear) {
      return aMonth - bMonth;
    }
    return aYear - bYear;
  },
  getActivityGroup({ moduleConfig, dutyActivity }) {
    let dutyActivityGroup = moduleConfig.dutyActivityTypeToGroupTypeMapping[dutyActivity.shortName];
    if (!dutyActivityGroup) dutyActivityGroup = dutyActivity.shortName;

    return { dutyActivityType: dutyActivity.shortName, dutyActivityGroup };
  },
  /**
   * TODO: Seems to be obsolete!!! Check and remove
   * Filtering and merging duty activity items.
   * @param {Object} dutyActivities
   * @param buildNonOverlappingChain - true to remove activities with last or current.blockcode is undefined
   * @returns filtered and merged dutyActivities
   */
  filterAndMergeDutyActivities(dutyActivities, buildNonOverlappingChain = false) {
    console.debug('filterAndMergeDutyActivities', dutyActivities.length);

    if (!dutyActivities || dutyActivities.length === 0) return null;
    let last = dutyActivities[0];
    let filteredAndMerged = [last];

    for (let i = 1; i < dutyActivities.length; i++) {
      let current = dutyActivities[i];

      last = filteredAndMerged[filteredAndMerged.length - 1];

      if (buildNonOverlappingChain) {
        if (!last.blockcode) {
          console.debug(`mergeCurrentWithLast last.blockcode=${last.blockcode} current.blockcode=${current.blockcode}`);
          //???mergeCurrentWithLast(last, current);
        } else if (!current.blockcode) {
          console.debug(`mergeCurrentWithLast with last and current blockcode===null`, last, current);
          //???mergeCurrentWithLast(last, current);
        } else if (isChainBroken(last, current)) {
          console.debug(
            `skipCurrentIf last.toMinutesAfterMidnight=${last.toMinutesAfterMidnight} current.fromMinutesAfterMidnight=${current.fromMinutesAfterMidnight}`
          );
        } else {
          filteredAndMerged.push(current);
        }
      } else {
        if (mergeIf(last, current, i)) {
          mergeCurrentWithLast(last, current);
        } else if (isChainBroken(last, current)) {
          console.debug(
            `skipCurrentIf last.toMinutesAfterMidnight=${last.toMinutesAfterMidnight} current.fromMinutesAfterMidnight=${current.fromMinutesAfterMidnight}`
          );
        } else {
          filteredAndMerged.push(current);
        }
      }
    }
    // console.debug('filteredAndMerged', filteredAndMerged);
    return filteredAndMerged;
  },
};
function mergeCurrentWithLast(last, current) {
  last.blockcode = current.blockcode;
  if (current.blockcode) last.blockcode = current.blockcode;
  if (current.startStopIdFk) last.startStopIdFk = current.startStopIdFk;
  if (current.endStopIdFk) last.endStopIdFk = current.endStopIdFk;
  if (current.fromMinutesAfterMidnight) last.fromMinutesAfterMidnight = current.fromMinutesAfterMidnight;
  if (current.toMinutesAfterMidnight) last.toMinutesAfterMidnight = current.toMinutesAfterMidnight;
  if (current.course) last.course = current.course;
  if (current.fzgNummer) last.fzgNummer = current.fzgNummer;
  if (current.konto) last.konto = current.konto;
  if (current.line) last.fzgStandplatz = current.lineline;
  if (current.longName) last.longName = current.longName;
  if (current.shortName) last.shortName = current.shortName;
  if (current.note) last.note = current.note;
  if (current.role) last.role = current.role;
  if (current.sort) last.sort = current.sort;
}
